import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { API_URL } from "./config";
import "./registerServiceWorker";

import VueSocketIO from "vue-socket-io";
Vue.use(VueSocketIO, API_URL);

Vue.config.productionTip = false;

import DatatableFactory from "vuejs-datatable/dist/vuejs-datatable.esm.js";
Vue.use(DatatableFactory);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
